import { useState } from 'react';

export default function SafeImage({ src, alt, ...props }) {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    return <img src={src} alt={alt} onError={() => setVisible(false)} {...props} />;
}
